'use es6';

import * as checked from '../../lib/checked';
export const Metric = checked.record({
  property: checked.string(),
  metricTypes: checked.list(checked.string()).defaultValue([]),
  percentiles: checked.list(checked.number()).optional()
});
export const Metrics = checked.list(Metric, 'Metrics').defaultValue([]);